import { Injectable } from '@angular/core';

import { Query, gql } from 'apollo-angular';
import { CancellationReason } from '../../models/cancellation-reason';
import { Resolvers } from '@apollo/client/core';

import { find } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CancellationReasonsGQL extends Query<CancellationReasonsGQLResponse, CancellationReasonsGQLVariables> {
  document = gql`
    query getCancellationReasons {
      cancellationReasons {
        cancellationReasonId
        isActive
        parentId
        name
        definition
        parentCategory @client
      }
    }
  `;
}

// tslint:disable-next-line
interface CancellationReasonsGQLVariables { }

interface CancellationReasonsGQLResponse {
  cancellationReasons: CancellationReason[];
}

interface CancellationReasonQuery {
  cancellationReasonId: number;
  isActive: boolean;
  parentId?: number;
  name: string;
}

export const ParentCancellationCategoryResolver: Resolvers = {
  CancellationReason: {
    parentCategory(parent: CancellationReasonQuery) {
      return '';
    }
  }
};
